import qs from "qs";

export const STRAPI_BASE_URL =
  process.env.REACT_APP_STRAPI_ENDPOINT || "http://localhost:1337";
export const STRAPI_CDN_URL =
  process.env.REACT_APP_CDN_URL || "http://localhost:1337/uploads";

export async function getNoticiasList() {
  try {
    const query = qs.stringify({
      populate: "*",
      sort: ["id:desc"]
    });

    const res = await fetch(`${STRAPI_BASE_URL}/api/plg-noticiass?${query}`);
    const data = await res.json();

    return data.data || [];
  } catch (err) {
    console.error("Error cargando noticias:", err);
    return [];
  }
}

export async function getNoticiaBySlug(slug: string) {
  try {
    const url = `${STRAPI_BASE_URL}/api/plg-noticiass?filters[slug][$eq]=${slug}&populate=*`;

    const res = await fetch(url);
    const data = await res.json();

    console.log("Respuesta de Strapi:", data);

    return data.data?.[0] || null;
  } catch (err) {
    console.error("Error obteniendo detalle:", err);
    return null;
  }
}